import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class FlashSaleStore {
    PAGE_SIZE = 10;
    list = [];
    pageSize = this.PAGE_SIZE;
    pageNum = 1;
    keyword = '';
    refreshing = false;

    constructor() {
        makeAutoObservable(this)
    }

    init() {
        this.list = [];
        this.pageSize = this.PAGE_SIZE;
        this.pageNum = 1;
        this.keyword = '';
        this.refreshing = false;
    }

    /**
     * 获取商品列表
     */
    async fetchList() {
        try {
            this.refreshing = true;
            const {pageSize, pageNum, keyword} = this;

            this.list = await Api.secKillList({
                page: pageNum,
                size: pageSize,
                keyword
            });

        } catch (error) {
        } finally {
            this.refreshing = false;
        }
    }


}

const store = new FlashSaleStore();

export default store;
